<div class='container-fluid portal-container'>
  <ng4-loading-spinner> </ng4-loading-spinner>
  <app-auth-nav></app-auth-nav>
  <app-nav></app-nav>
  <div class='row container-row-2'>
    <div class='col-sm-12 body-content'>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html